module.exports = __webpack_public_path__ + "img/triple-face-btn-bg.bc97206c.svg";